import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * AdminSectionLayout — shared chrome for the 6 admin section pages
 * (Feb 6, 2026 admin restructure).
 *
 * Sticky header with back arrow → /admin (the hub), an icon bubble,
 * title + one-line subtitle. Children render below in a max-w-2xl
 * column with mobile-safe padding.
 */
export default function AdminSectionLayout({ title, subtitle, icon: Icon, accent = "blue", testid, children }) {
  const accentBg = {
    blue:    "bg-blue-100 text-blue-600",
    emerald: "bg-emerald-100 text-emerald-600",
    violet:  "bg-violet-100 text-violet-600",
    amber:   "bg-amber-100 text-amber-600",
    rose:    "bg-rose-100 text-rose-600",
    slate:   "bg-slate-100 text-slate-600",
    indigo:  "bg-indigo-100 text-indigo-600",
  }[accent] || "bg-blue-100 text-blue-600";

  return (
    <div data-testid={testid} className="min-h-dvh no-overflow-x bg-slate-50 dark:bg-slate-950 pb-12">
      <header className="bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800 sticky top-0 z-30">
        <div className="max-w-2xl mx-auto px-4 h-14 flex items-center gap-3">
          <Link
            to="/admin"
            data-testid="admin-back-to-hub"
            className="text-slate-400 hover:text-slate-700 dark:hover:text-white"
            aria-label="Back to Admin Home"
          >
            <ArrowLeft className="w-5 h-5" />
          </Link>
          {Icon ? (
            <div className={`w-8 h-8 rounded-lg ${accentBg} flex items-center justify-center flex-shrink-0`}>
              <Icon className="w-4 h-4" />
            </div>
          ) : null}
          <div className="flex-1 min-w-0">
            <p className="font-extrabold text-slate-900 dark:text-white text-base leading-tight truncate">{title}</p>
            {subtitle ? <p className="text-[11px] text-slate-500 leading-tight truncate">{subtitle}</p> : null}
          </div>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 pt-5 space-y-3">{children}</main>
    </div>
  );
}
